var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var Specialization = /** @class */ (function (_super) {
    __extends(Specialization, _super);
    function Specialization() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Specialization.prototype.getId = function () {
        return Number(this.id);
    };
    Specialization.prototype.getName = function () {
        return this.name;
    };
    return Specialization;
}(Model));
export default Specialization;
